import type { Video } from 'api';
import cx from 'classnames';
import dynamic from 'next/dynamic';
import { memo } from 'react';

const Controls = dynamic(() => import('./Controls/Controls'), {
  ssr: false
});

const SubtitleCredits = dynamic(() => import('./Subtitles/subtitle-credits'), {
  ssr: false
});

const SubtitleCue = dynamic(() => import('./Subtitles/subtitle-cue'), {
  ssr: false
});

interface PlayerOverlayProps {
  displayControls: boolean;
  displaySubtitles: boolean | undefined;
  hideControls: boolean;
  isMobile: boolean;
  animateVisibleClasses: string;
  animateSubtitlePositionClasses: string;
  playerTalkData: Video['playerData'];
}

function PlayerOverlay({
  displayControls,
  displaySubtitles,
  hideControls,
  isMobile,
  animateVisibleClasses,
  animateSubtitlePositionClasses,
  playerTalkData
}: PlayerOverlayProps) {
  return (
    <>
      {displayControls && (
        <div
          id="controls-container"
          className={cx(
            'pointer-events-none absolute z-20 size-full lg-tui:bottom-0 lg-tui:h-auto',
            animateVisibleClasses
          )}
        >
          <Controls playerTalkData={playerTalkData} />
        </div>
      )}

      {displaySubtitles && (
        <div
          id="subtitles-container"
          className="pointer-events-none size-full opacity-100"
        >
          {!hideControls && !isMobile && (
            <div
              className={`absolute top-0 hidden w-full md:block ${animateVisibleClasses}`}
            >
              <SubtitleCredits />
            </div>
          )}

          <SubtitleCue
            className={cx(
              'absolute bottom-7 w-full md-tui:bottom-16 lg-tui:bottom-10',
              animateSubtitlePositionClasses
            )}
          />
        </div>
      )}
    </>
  );
}

export default memo(PlayerOverlay);
